"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var compat_1 = require("preact/compat");
var YotpoStar_1 = require("./YotpoStar");
var yotpo_img_1 = require("../../constants/img/yotpo-img");
var YotpoBottomline = function (_a) {
    var bottomline = _a.bottomline, filterByScore = _a.filterByScore, selected = _a.selected;
    if (!bottomline.star_distribution) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    // Fix the dicimal placement to 1 for avg score and set it as a number
    var avgScore = +Number(bottomline.average_score).toFixed(1);
    // Convert star_distribution (object) to an array in a reversed order (5, 4, 3, 2, 1)
    var starDist = Object.entries(bottomline.star_distribution).reverse();
    // Detect if item is hovered on
    return ((0, preact_1.h)("div", { class: "yotpo-bottomline-v2" },
        (0, preact_1.h)("div", { class: "yotpo-bottomline__top" },
            (0, preact_1.h)("p", { class: "yotpo-bottomline__header" }, "Customer Reviews"),
            (0, preact_1.h)("div", { class: "yotpo-bottomline__stats" },
                (0, preact_1.h)("div", { class: "yotpo-bottomline__star-box" },
                    (0, preact_1.h)("p", { class: "yotpo-bottomline__avg-score" }, avgScore),
                    (0, preact_1.h)(YotpoStar_1.default, { score: avgScore, size: "large", id: "yotpo-review-bottomline-star", color: "#FAA943", starFilledImg: yotpo_img_1.YOTPO_STAR_FILLED_ORANGE, starOutlinedImg: yotpo_img_1.YOTPO_STAR_OUTLINED_ORANGE })),
                (0, preact_1.h)("p", { class: "yotpo-bottomline__review-count" },
                    bottomline.total_review,
                    " Reviews"))),
        (0, preact_1.h)("div", { class: "yotpo-bottomline__body" },
            (0, preact_1.h)("div", { class: "yotpo-bottomline__dist" }, starDist.map(function (_a) {
                var score = _a[0], count = _a[1];
                return ((0, preact_1.h)("div", { class: "yotpo-bottomline__dist-data\n                ".concat(selected !== 0 ? 'yotpo-bottomline__dist-data--filtered' : '', "\n                ").concat(selected === +score ? 'yotpo-bottomline__dist-data--selected' : '', "\n              "), key: "yotpo-bottomline__dist-data--".concat(score), onClick: function () { return filterByScore(+score); } },
                    (0, preact_1.h)("div", { class: "yotpo-bottomline__dist-score" },
                        score,
                        " Star"),
                    (0, preact_1.h)("div", { class: "yotpo-bottomline__dist-full-bar" },
                        (0, preact_1.h)("div", { class: "yotpo-bottomline__dist-colored-bar", style: "width: ".concat((count / bottomline.total_review) * 100, "%") }))));
            })))));
};
exports.default = (0, compat_1.memo)(YotpoBottomline);
